import $ from 'jquery';

function layout(): void {
  const columns = Array.from(document.querySelectorAll('.l-waterfall-column'));
  const columnCount = columns.length;
  if (columnCount > 0) {
    const items = Array.from(
      document.querySelectorAll<HTMLElement>('.news')
    ).sort((a, b) => {
      return parseInt(a.dataset.order!) - parseInt(b.dataset.order!);
    });
    const width = window.innerWidth;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const columnIndex = width < 740 ? 0 : i % columns.length;
      const column = columns[columnIndex];
      column.appendChild(item);
    }
  }
}

$(document).on('ready turbo:load turbo:frame-load resize', layout);
